var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducticon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1453 7.74376C25.1424 7.74376 25.1396 7.74261 25.1376 7.74056C25.1355 7.73851 25.1344 7.73573 25.1344 7.73283C24.9763 7.46367 24.7499 7.24106 24.4781 7.08751L14.8531 1.67345C14.5924 1.52785 14.2987 1.45142 14 1.45142C13.7013 1.45142 13.4077 1.52785 13.1469 1.67345L3.52188 7.08751C3.25011 7.24106 3.02372 7.46367 2.86563 7.73283C2.86563 7.73573 2.86448 7.73851 2.86243 7.74056C2.86038 7.74261 2.8576 7.74376 2.8547 7.74376V7.76564C2.70348 8.02047 2.62411 8.31151 2.62501 8.60783V19.3922C2.62556 19.704 2.70888 20.01 2.86646 20.2791C3.02403 20.5481 3.25021 20.7705 3.52188 20.9235L13.1469 26.3375C13.3892 26.4697 13.6586 26.5445 13.9344 26.5563H14.0875C14.3563 26.5443 14.6186 26.4694 14.8531 26.3375L24.4781 20.9235C24.7498 20.7705 24.976 20.5481 25.1336 20.2791C25.2911 20.01 25.3745 19.704 25.375 19.3922V8.60783C25.3766 8.30451 25.2973 8.00625 25.1453 7.74376ZM14 3.19376L22.7172 8.09376L19.3703 9.99689L10.5438 5.1297L14 3.19376ZM14.0984 12.9938L5.29376 8.09376L8.75001 6.14689L17.5875 11.0141L14.0984 12.9938ZM14.8859 24.3141L14.9734 14.5141L18.4844 12.5125V16.6797C18.4844 16.9118 18.5766 17.1343 18.7407 17.2984C18.9048 17.4625 19.1273 17.5547 19.3594 17.5547C19.5914 17.5547 19.814 17.4625 19.9781 17.2984C20.1422 17.1343 20.2344 16.9118 20.2344 16.6797V11.5172L23.625 9.5922V19.3922L14.8859 24.3141Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducticon);
export default __webpack_public_path__ + "static/media/Product icon.2115f27b73c462e6870e454a65b490fd.svg";
export { ForwardRef as ReactComponent };